export var CREATE_FORM_STATE_ASYNC = 'CREATE_FORM_STATE_ASYNC';
export var CREATE_FORM_STATE = 'CREATE_FORM_STATE';
export var UPDATE_FORM_STATE_ASYNC = 'UPDATE_FORM_STATE_ASYNC';
export var UPDATE_FORM_STATE = 'UPDATE_FORM_STATE';
export var DELETE_FORM_STATE_ASYNC = 'DELETE_FORM_STATE_ASYNC';
export var DELETE_FORM_STATE = 'DELETE_FORM_STATE';